<template>
  <div>
    <Dialog
      v-model="questionnaireVisible"
      v-bind="$attrs"
      :before-close="beforeClose"
      fullscreen
      class="questionnaire-dialog"
      @open="handleOpen"
    >
      <iframe
        v-if="questionnaireVisible"
        :src="questionnaireUrl"
        ref="iframeRef"
      />
    </Dialog>
  </div>
</template>

<script setup>
// 问卷的地址
import { ref } from "vue";
import Dialog from "@/components/Common/Dialog.vue";
import { local } from "@/utils/storage.js";
import questionnaireApi from "@/api/questionnaire.js";
import { objectToQueryString } from "@/hooks/utils.js";
import { getCssVar } from "@/utils/themed.js";
import { useQuestionnaireStore } from "@/store/questionnaire.js";

const props = defineProps({
  // 问卷地址
  url: {
    type: String,
  },
  // 问卷操作类型：1=新增问卷
  type: {
    type: Number,
  },
  // 问卷id
  qid: {
    type: String,
  },
  // 患者信息
  patient: {
    type: Object,
  },
  // 额外的路径参数
  params: {
    type: Object,
    default: {},
  },
});
const QuestionnaireStore = useQuestionnaireStore();
const questionnaireVisible = defineModel(); //弹框展示隐藏
const iframeRef = ref(null); //iframe ref
const questionnaireUrl = ref(""); //问卷地址
let questionnaireAddress;

// 弹出框打开的回调
const handleOpen = async () => {
  try {
    questionnaireUrl.value = "";
    // 如果传递了地址则直接使用
    if (props.url) return (questionnaireUrl.value = props.url);
    const { access_token, refresh_token } = await QuestionnaireStore.getToken();
    const sysData = await getSysData(props.qid);
    const UserId = local.get("id");
    const UserName = local.get("userName");
    const themeColor = getCssVar("--themed-color"); //主题色

    switch (props.type) {
      case 1: //新增问卷
        const query1 = objectToQueryString({
          access_token,
          refresh_token,
          sysData,
          UserId,
          type: 1,
          questionType: 0,
          time: new Date().getTime(),
          ...props.params,
          themeColor,
        });
        questionnaireUrl.value = `${questionnaireAddress}/#/PcIframe?${query1}`;
        break;
      case 2: //编辑问卷
        const query2 = objectToQueryString({
          qid: props.qid,
          access_token,
          refresh_token,
          type: 2,
          questionType: 0,
          time: new Date().getTime(),
          themeColor,
          ...props.params,
        });
        questionnaireUrl.value = `${questionnaireAddress}/#/PcIframe?${query2}`;
        break;
      case 3: //查看 预览问卷
        const query3 = objectToQueryString({
          access_token,
          refresh_token,
          qid: props.qid,
          type: 3,
          time: new Date().getTime(),
          ...props.params,
          themeColor
        });
        questionnaireUrl.value = `${questionnaireAddress}/#/PcIframe?${query3}`;
        break;
      case 4: //填写问卷
        const collectSysData = await getCollectSysData();
        const query4 = objectToQueryString({
          access_token,
          refresh_token,
          sysData: collectSysData,
          qid: props.qid,
          userId: props.patient.id,
          userName: props.patient.name,
          fillinId: UserId,
          fillinName: UserName,
          phone: 1,
          visitsNumber: 1,
          type: 4,
          time: new Date().getTime(),
          ...props.params,
          themeColor
        });
        questionnaireUrl.value = `${questionnaireAddress}/#/PcIframe?${query4}`;
        break;
      case 5: //修改已收集问卷
        const query5 = objectToQueryString({
          access_token,
          refresh_token,
          fillinId: UserId,
          fillinName: UserName,
          qid: props.qid,
          type: 5,
          time: new Date().getTime(),
          ...props.params,
          themeColor
        });
        questionnaireUrl.value = `${questionnaireAddress}/#/PcIframe?${query5}`;
        break;
      default:
    }
  } catch (e) {
    questionnaireVisible.value = false;
  }
};
// 问卷关闭前的回调
const beforeClose = (done) => {
  if (props.type === 1) {
    iframeRef.value.contentWindow.postMessage(
      {
        type: "close",
      },
      "*",
    );
    window.addEventListener("message", (message) =>
      messageEvent(message, done),
    );
  } else {
    done();
  }
};

// message事件回调
function messageEvent(message, done) {
  const { data } = message;
  if (data.type === "saveStatus") {
    window.removeEventListener("message", messageEvent);
    done();
  }
}

// 获取组织sysData
const getSysData = async (qid) => {
  let res = await questionnaireApi.getSysData(qid);
  return res.data;
};
// 获取收集问卷sysData
const getCollectSysData = async () => {
  let res = await questionnaireApi.getCollectSysData(props.patient.id);
  return res.data;
};
// 获取问卷地址
QuestionnaireStore.getAddress(async (data) => {
  questionnaireAddress = data;
});
</script>

<style scoped lang="scss">
.questionnaire-dialog {
  #body {
    padding: 0 !important;
    overflow: hidden !important;

    iframe {
      border: none;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
